module.exports = __webpack_public_path__ + "static/img/img_3.2165f1c3.jpg";